import {useQuery} from '@tanstack/react-query';
import {fetchRecords} from '../services/BillingProvidersService';
import {BillingProvider} from '../types.ts';

// FNP-616: the channel selector is now CATALOG-DRIVEN. The legal set of billing channels is
// the set of ENABLED BillingProvider rows (their lowercase-underscore `key` is the canonical
// channel token — one vocabulary shared with the metering channel + provider_mappings).
// Replaces the hardcoded BillingChannel enum that used to enumerate STRIPE/AWS_MARKETPLACE/
// INTERNAL on the frontend: onboarding a provider no longer needs a UI change.
//
// Returns FormikSelect-shaped options ({value, label}) where value = the catalog key (the
// token persisted on MeterAssignment.channel) and label = the human name (falls back to key).

export interface ChannelOption {
    value: string;
    label: string;
}

export const useChannelOptions = () => {
    const query = useQuery({
        queryKey: ['billing-providers', 'enabled-channel-options'],
        queryFn: () => fetchRecords({filter: {status: 'Enabled'}, limit: 100}),
    });

    const options: ChannelOption[] = (query.data?.items ?? [])
        .filter((p): p is BillingProvider => !!p && !!p.key)
        .map((p) => ({value: p.key, label: p.name ?? p.key}));

    return {
        options,
        loading: query.isLoading,
        error: query.error,
    };
};
